import {
  type CohortDslLegacy,
  type StudyPeriodRestrictionsLegacy,
} from '@verantos-dev/types-cohorts';
import {
  getFullDslQueryString,
  transformStudyPeriodRestrictionsToDsl,
} from '@verantos-dev/util-cohort-definition-ui-to-dsl';

export const getNextCohortDslForStudyPeriodRestriction = (
  nextStudyPeriodRestrictions: StudyPeriodRestrictionsLegacy,
  currentCohortDsl?: CohortDslLegacy
): CohortDslLegacy => {
  return {
    inclusionCriteria: currentCohortDsl?.inclusionCriteria ?? [],
    exclusionCriteria: currentCohortDsl?.exclusionCriteria ?? [],
    studyPeriodRestrictions: transformStudyPeriodRestrictionsToDsl(nextStudyPeriodRestrictions),
    subjectVariables: currentCohortDsl?.subjectVariables ?? [],
    indexDate: currentCohortDsl?.indexDate,
    simpleEvents: currentCohortDsl?.simpleEvents ?? [],
    derivedEvents: currentCohortDsl?.derivedEvents ?? [],
  };
};

export const getFullCohortDslForStudyPeriodRestriction = (
  studyPeriodRestrictions: StudyPeriodRestrictionsLegacy,
  currentCohortDsl?: CohortDslLegacy
): string => {
  const nextCohortDsl = getNextCohortDslForStudyPeriodRestriction(
    studyPeriodRestrictions,
    currentCohortDsl
  );
  return getFullDslQueryString(nextCohortDsl);
};
